import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ViewMode = 'list' | 'card' | 'calendar' | 'kanban';
export type CalendarViewType = 'month' | '3day';

interface ViewState {
  viewModes: Record<string, ViewMode>;
  calendarViewTypes: Record<string, CalendarViewType>;
  getViewMode: (page: string) => ViewMode;
  setViewMode: (page: string, mode: ViewMode) => void;
  getCalendarViewType: (page: string) => CalendarViewType;
  setCalendarViewType: (page: string, type: CalendarViewType) => void;
}

export const useViewStore = create<ViewState>()(
  persist(
    (set, get) => ({
      viewModes: {},
      calendarViewTypes: {},
      getViewMode: (page) => {
        return get().viewModes[page] ?? 'list';
      },
      setViewMode: (page, mode) =>
        set((state) => ({
          viewModes: { ...state.viewModes, [page]: mode },
        })),
      getCalendarViewType: (page) => {
        return get().calendarViewTypes[page] ?? 'month';
      },
      setCalendarViewType: (page, type) =>
        set((state) => ({
          calendarViewTypes: { ...state.calendarViewTypes, [page]: type },
        })),
    }),
    {
      name: 'littlebooker-view-preferences',
    }
  )
);
